<template>
    <div class="vm-avatar flex-box lhi flex-wrap" @click="all_jump">
        <div
            class="avatar-box relative"
            :class="{ 'is-only-avatar': is_only_avatar }"
        >
            <a class="inner-box block pointer" v-if="!is_no_href"
                :href="is_right_info ? $userlink(user).path : false"
                :_blank="is_href_blank ? 'target' : false"
                @click="jump">
                <pic class="avatar-img" v-if="user.avatar" :src="user.avatar" width="120" height="120"></pic>
            </a>
            <div class="inner-box" v-else>
                <pic
                    v-if="user.avatar"
                    class="avatar-img"
                    :src="user.avatar"
                    width="120"
                    height="120"
                ></pic>
            </div>
            <div class="bubble" v-if="bubble_text">{{ bubble_text }}</div>
            <div
                class="sign pointer"
                @click="is_menu ? false :tip($t('c.Avatar.text1'))"
                v-if="user.is_verified == 1 && user.verified_type == 1"
            >
                <img src="/static/img/asset/afd-admin-sign.png" alt />
            </div>
        </div>
        <div
            class="flex-box flex-justify-content-center flex-direction-column avatar-content flex-item-1"
            :class="{'flex-align-self-center':name_center}"
            v-if="!is_only_avatar"
        >
            <div class="user-name flex-box flex-justify-content-space-between flex-align-items-center">
                <span class="flex-box flex-a-center">
                <a
                    v-if="!is_no_href"
                    :href="is_right_info ? $userlink(user).path : false"
                    :_blank="is_href_blank ? 'target' : false"
                    @click="is_right_info ? false : $mixin_router_push($userlink(user).path, is_href_blank)"
                    class="avatar-name black-8 gl-hover-text-purple flex-align-items-center"
                    :class="{ 'text-overflow-1': !is_for_html2canvas, 'flex-box' : name_width == 0}"
                    :style="{'max-width': name_width > 0 ? `${name_width}px` : false}"
                >
                    <!-- <span class="flex-box flex-a-center"> -->
                      {{ user.name }}
                      <!-- <pic v-for="(item, i) in user.badge" :key="i" class="ml4 badge-icon" @click.native="stop" v-tooltip.bottom="{content:`${item.desc}`,trigger:browser_size == 'small' ? 'hover':`hover`, classes:'look5'}" :src="item.image" width="14"/> -->
                    <!-- </span>   -->
                    <slot name="name-after"></slot>
                </a>
                <span
                    class="black-8 avatar-name flex-align-items-center"
                    v-else
                    :class="{ 'text-overflow-1': !is_for_html2canvas, 'flex-box' : name_width == 0 }"
                    :style="{'max-width': name_width > 0 ? `${name_width}px` : false}"
                >
                    <!-- <span class="flex-box flex-a-center"> -->
                      {{ user.name }}
                      <!-- <pic v-for="(item, i) in user.badge" :key="i" class="ml4 badge-icon" @click.native="stop" v-tooltip.bottom="{content:`${item.desc}`,trigger:browser_size == 'small' ? 'hover':`hover`, classes:'look5'}" :src="item.image" width="14"/> -->
                    <!-- </span>   -->
                    <slot name="name-after"></slot>
                </span>
                <template v-if="is_show_badge">
                  <pic v-for="(item, i) in user.badge" @click.native="item.desc == '' ? open_badge($event, item) : false" :key="i" class="ml8 badge-icon pointer" :class="['size' + badge_size]" v-tooltip.bottom="{content:`${item.desc}`,trigger:browser_size == 'small' ? 'click':`hover`, classes:'look5'}" :src="item.image" :width="badge_size" :height="badge_size" type="5"/>
                </template>
                </span>  
                <slot name="name-right"></slot>
                <!--<div class="flex-box">-->
                <!--<router-link v-if="!is_no_href" :to="$userlink(user)"-->

                <!--class="avatar-name black-8 gl-hover-text-purple text-overflow-1">{{user.name}}</router-link>-->
                <!--<div class="black-8 text-overflow-1 avatar-name" v-else>{{user.name}}</div>-->
                <!--<slot name="name-after"></slot>-->
                <!--</div>-->
            </div>
            <div class="user-intro fs12">
                <slot name="doing"></slot>
                <slot name="info"></slot>
            </div>
        </div>
        <slot name="right"></slot>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "avatar",
    props: {
        user: {
            type: Object,
            default: function() {
                return {};
            }
        },
        is_right_info:{
            default: function() {
                return false;
            }
        },
        is_only_avatar: {
            default: false
        },
        name_width:{
            default: function() {
                return 0;
            }
        },
        name_center:{
            default: function() {
                return false;
            }
        },
        is_href_blank: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        is_no_href: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        is_all_jump: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        is_show_badge: {
          default: function() {
              return true;
          }
        },
        is_menu: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        bubble_text: {
            type: [String, Number],
            default: function() {
                return "";
            }
        },
        is_for_html2canvas: {
            //for 截图
            default: false
        },
        badge_size: {
            default: 14
        }
    },
    computed: {
      ...mapState("app", ['is_applying_apple']),
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        tip(str) {
            this.$notify({
                title: str
            });
        },
        jump(){
            if(this.is_right_info){
                return false
            }
            let link = this.$userlink(this.user);
            this.$mixin_router_push(link.path, this.is_href_blank);
        },
        all_jump(){
          if(this.is_no_href){
            return false;
          }
          if(this.is_all_jump){
            this.jump()
          }
        },
        stop(e){
          e.stopImmediatePropagation();
        },
        open_badge(e, badge){
          if(this.is_applying_apple){
            return 0;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
          badge.text_congratulation = `${this.user.name} 获得的会员徽章`
          this.$modal.show(
            () => import("@/components/ModalBadge"),
            {
              badge,
              this_user: this.user,
            },
            {
                pivotY: this.browser_size == "small" ? 0.4 : 0.2,
                clickToClose: false,
                classes: "v--modal-badge v--modal",
                height: "auto",
                width: 280,
                adaptive: this.browser_size == "small" ? true : false,
            }
          );
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-avatar {
  align-items: flex-start;
  &.flex-align-items-center{
    align-items: center;
  }

  .avatar-box {
    margin-right: px2rem(32);
    position: relative;

    &.is-only-avatar {
      margin-right: px2rem(0) !important;
    }

    .sign {
      width: px2rem(24);
      height: px2rem(24);
    }

    .inner-box {
      overflow: hidden;
      position: relative;
      background: $black-05;
      width: px2rem(80);
      height: px2rem(80);
      border-radius: 10000px;
    }
  }

  .sign {
    position: absolute;
    background: $white;
    border-radius: 1000px;
    right: 0;
    bottom: 0;
    padding: px2rem(2);
    transform: translate(px2rem(1), px2rem(1));

    img {
      display: block;
    }
  }

  .avatar-img {
    border-radius: 10000px;
  }
  &.fs12{
    .avatar-name {
      font-size:12px;
    }
  }

  .user-name {
    font-size: fs2rem(24);
    font-weight: 600;
    /* line-height 1 */
    line-height: 1.4;
    word-break: break-all;
  }

  &.purple {
    .user-name {
      color: $purple;
    }
  }

  .user-intro {
    color: $black-8;
    word-break: break-all;
  }

  &.wh24 {
    .avatar-box {
      margin-right: px2rem(16);

      .sign {
        width: px2rem(8);
        height: px2rem(8);
      }

      .inner-box {
        width: px2rem(24);
        height: px2rem(24);
      }
    }

    .user-name {
      font-size: fs2rem(14);
      font-weight: normal;
    }
  }

  &._wh32 {
    .avatar-box {
      margin-right: px2rem(8);

      .sign {
        width: px2rem(8);
        height: px2rem(8);
      }

      .inner-box {
        width: px2rem(32);
        height: px2rem(32);
      }
    }

    .user-name {
      font-size: fs2rem(14);
    }
  }

  &.wh40 {
    .avatar-box {
      margin-right: 8px;

      .sign {
        width: 10px;
        height: 10px;
      }

      .inner-box {
        width: 40px;
        height: 40px;
      }
    }
  }

  &.wh48 {
    .avatar-box {
      margin-right: px2rem(16);

      .sign {
        width: px2rem(16);
        height: px2rem(16);
      }

      .inner-box {
        width: px2rem(48);
        height: px2rem(48);
      }
    }

    .user-name {
      font-size: fs2rem(16);
    }
  }

   &.wh56 {
    .avatar-box {
      margin-right: px2rem(16);
      .sign {
        width: px2rem(16);
        height: px2rem(16);
      }

      .inner-box {
        width: px2rem(56);
        height: px2rem(56);
      }
    }
    .user-name {
      font-size: fs2rem(16);
    }
  }

  &.wh64 {
    .avatar-box {
      .sign {
        width: px2rem(12);
        height: px2rem(12);
      }

      .inner-box {
        width: 64px;
        height: 64px;
      }
    }
  }

  &.wh120 {
    .avatar-box {
      margin-right: px2rem(60);

      .inner-box {
        width: px2rem(120);
        height: px2rem(120);
      }

      .sign {
        width: px2rem(32);
        height: px2rem(32);
        padding: px2rem(4);
        transform: translate(px2rem(2), px2rem(2));
      }
    }
  }

  .avatar-img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .bubble {
    background-color: $cyan;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: fs2rem(10);
    border-radius: 10000px;
    position: absolute;
    width: px2rem(20);
    height: px2rem(20);
    top: 0;
    right: 0;
    transform: translate(30%, -30%);
    color: $white;
  }
  .badge-icon{
    border-radius:1px;
    &.size14{
      width:14px;
      height:14px;
    }
    &.size16{
      width:16px;
      height:16px;
    }
  }

  @media (max-width: $width-mobile) {
    .avatar-box {
      margin-right: px2rem(24);
    }

    &.wh48 {
      .avatar-box {
        margin-right: px2rem(16);
      }
    }

    &.mq-80-48 { // media-query
      .avatar-box {
        .inner-box {
          width: px2rem(48);
          height: px2rem(48);
        }

        margin-right: px2rem(16);
      }
    }

    &.mq-80-64 { // media-query
      .avatar-box {
        .inner-box {
          width: px2rem(64);
          height: px2rem(64);
        }

        margin-right: px2rem(16);
      }
    }

    &.mq-120-64 { // media-query
      &.wh120 {
        .avatar-box {
          .inner-box {
            width: px2rem(64);
            height: px2rem(64);
          }

          margin-right: px2rem(16);

          .sign {
            width: px2rem(24);
            height: px2rem(24);
            padding: px2rem(3);
            transform: translate(px2rem(1), px2rem(1));
          }
        }
      }
    }
  }
}
</style>
